import { Deserializable } from "./deserializable";
import { NavEntity } from "./nav-entity";

export class Train implements Deserializable, NavEntity {
	applicationMode: string;
	assemblyId: number;
	assignedPL: string;
	availability: number;
	branch: string;
	connection: string;
	contractType: string;
	controlSystem: string;
	country: string;
	dataIntegrity: string;
	drivenUnitTypes: string;
	drivenUnits: string;
	driverTypes: string;
	drivers: string;
	facDate: string;
	health: string;
	industry: string;
	lTSAExpDate: string;
	openSupportCases: number;
	operatingStatus: string;
	operation: string;
	operationMode: string;
	pACDate: string;
	powerRate: string;
	projectName: string;
	region: string;
	reliability: number;
	serviceFactor: number;
	servicePattern: string;
	siteId: number;
	trainId: number;
	trainName: string;
	trainNo: number;

	lastConnection: string;
	lastConnectionReady = false;

	presentation = false;

	deserialize(input: any): any {
		Object.assign(this, input);
		return this;
	}

	getName(): string {
		return this.presentation ? "Train" : this.projectName;
	}

	getDrivers(): string {
		return this.presentation ? "Drivers ***" : this.drivers;
	}

	getType(): "customer" | "site" | "train" {
		return "train";
	}

	getId(): number {
		return this.trainId;
	}

	getIcon(): string {
		return "assets/images/trainIcon.png";
	}

	getOperationalIcon(): string {
		if (this.operation == null) {
			return "trainStatusGray";
		} else {
			switch (this.operation.toLowerCase()) {
				case "running":
					return "oi oi-check";
				case "not running":
					return "oi oi-x";
				case "tripped":
					return "oi oi-x";
				case "no data":
					return "oi oi-ban";
			}
		}
	}

	getOperationColor(): string {
		if (this.operation == null) {
			return "gray";
		} else {
			switch (this.operation.toLowerCase()) {
				case "running":
					return "green";

				case "not running":
					return "orange";

				case "tripped":
					return "red";

				case "no data":
					return "gray";
			}
		}
	}

	togglePresentation() {
		this.presentation = !this.presentation;
	}
}



// WEBPACK FOOTER //
// ./src/models/train.ts